import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api-client";
import type { OrgAdminDashboardData } from "@/hooks/queries/org-admin-dashboard-types";

// GET /org-admin/dashboard (Story 14.1, FR76) — seat pool + active clinician
// roster for the org_admin's own organization (resolved server-side from the
// signed org_id claim). A post-session data call, so it rides apiFetch's
// silent-refresh path (skipAuthRefresh deliberately omitted).

/** Root key — invalidateQueries(ORG_ADMIN_DASHBOARD_QUERY_KEY) after 14.2's invite lands. */
export const ORG_ADMIN_DASHBOARD_QUERY_KEY = ["org-admin", "dashboard"] as const;

export function useOrgAdminDashboard() {
  return useQuery({
    queryKey: ORG_ADMIN_DASHBOARD_QUERY_KEY,
    queryFn: () => apiFetch<OrgAdminDashboardData>("/org-admin/dashboard"),
  });
}
